import { render, staticRenderFns } from "./processHeadFour.vue?vue&type=template&id=6525524a&scoped=true"
import script from "./processHeadFour.vue?vue&type=script&lang=js"
export * from "./processHeadFour.vue?vue&type=script&lang=js"
import style0 from "./processHeadFour.vue?vue&type=style&index=0&id=6525524a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6525524a",
  null
  
)

export default component.exports